<template>
  <div>
    <h2 class="title">{{L10n('chosen-parts')}}</h2>
    <grid
      ref="grid"
      :config="gridConfig"
      class="no-grid-border"/>
  </div>
</template>

<script>
import gridConfig from './GridConfig'

export default {
  name: 'MoreQuotesGridChosenIndex',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index')
  },
  props: {
    listSelectedQuotes: { type: Array }
  },
  watch: {
    listSelectedQuotes: {
      immediate: true,
      handler () {
        setTimeout(() => {
          this.getGrid().data = this.listSelectedQuotes
            .map((item) => ({ ...item, ranked_: {}, status_: {} }))
        }, 500)
      }
    }
  },
  data () {
    return {
      gridConfig: gridConfig
    }
  },
  methods: {
    getGrid () {
      return this.$refs['grid']
    }
  }
}
</script>
